import axios from "axios";
import { getToken, logout } from "./auth";

export const baseURLAPI = process.env["REACT_APP_URL_API"];

const api = axios.create({
  baseURL: `${baseURLAPI}api/v2/`,
});

// Interceptor de request - adiciona token de autenticação
api.interceptors.request.use(async config => {
  const token = getToken();
  const newConfig = config;
  if (token) {
    newConfig.headers.Authorization = `Bearer ${token}`;
  }
  return newConfig;
});

// Interceptor de response - trata erros globais
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      logout();
      window.location.href = "/unauthorized";
    }

    return Promise.reject(error);
  }
);

export default api;
